import React, { useState } from 'react';
import propTypes from 'prop-types';
import { Modal } from '../../../component';
import { fileManagementApi } from '../../../services/apis';
import { fileHandlerUrl } from '../../../utils/consts/server';
import './fileUpload.scss';

const UploadPassport = ({
  tabIndex = 0,

  returnData = () => {},
  isOptional,
  fileAccepted,
  title,
  intl,
  customClassName = 'bg-secondary text-white',
}) => {
  const DEFAULT_MODAL = {
    isShow: false,
    content: '',
    title: 'booking.passportImage',
  };
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(DEFAULT_MODAL);
  const [file, setFile] = useState(null);

  return (
    <div
      className={`w-100 d-flex justify-content-end font-small py-2 px-0 fileUpload cursor-pointer ${customClassName} `}
      tabIndex={tabIndex}
    >
      <div className="d-flex bg-white text-primary text-underline align-items-center pt-2 ">
        <input
          id="uploadPassport"
          className="upload w-25 border border-light"
          onChange={async (event) => {
            setLoading(true);
            const formData = new FormData();
            let selectedFile = event.target.files[0];
            formData.append('file', selectedFile, selectedFile.name);
            await fileManagementApi
              .uploadPassport(formData)
              .then(async (res) => {
                if (!selectedFile) return;
                setLoading(false);
                setFile(URL.createObjectURL(selectedFile));
                await returnData(res);
              })
              .catch((error) => {
                setLoading(false);
                returnData(error);
              });
          }}
          type="file"
          accept={fileAccepted}
          required={!isOptional}
        />
        <label
          htmlFor="uploadPassport"
          className="d-flex align-items-center cursor-pointer px-2"
        >
          {title}
        </label>
      </div>
      <div className="d-flex align-items-center px-2 ">
        {' '}
        {!loading ? (
          <img
            onClick={() => setModal({ ...modal, isShow: true })}
            src={file || `${fileHandlerUrl}/file/show/no-image.png`}
            alt="passport"
            width={'25vw'}
            height={'25vw'}
          />
        ) : (
          <img
            width={40}
            src={require('../../../content/images/icon/small-loading.gif')}
            alt="loading"
          />
        )}
      </div>

      <Modal
        modlaSizeClass=" w-50 "
        title={
          <h5 className="modal-title text-center w-100 font-weight-bold text-uppercase text-primary">
            {intl.formatMessage({ id: modal?.title })}
          </h5>
        }
        isOpen={modal?.isShow}
        onClose={() => setModal(DEFAULT_MODAL)}
      >
        <div className="w-100 d-flex justify-content-center align-items-center">
          <img src={file} width={350} height={350} alt="passport" />
        </div>
      </Modal>
    </div>
  );
};

UploadPassport.propTypes = {
  isOptional: propTypes.bool,
  title: propTypes.string,
  customClassName: propTypes.string,
  fileAccepted: propTypes.string,
  recieveFile: propTypes.func,
};
UploadPassport.defaultProps = {
  isOptional: true,
  customClassName: '',
  title: 'Upload File',
  fileAccepted: 'image/*',
  recieveFile: () => {},
};

export default UploadPassport;
